module.exports = __webpack_public_path__ + "static/media/watchlist_checkbox_indeterminate.5abeaf5b.svg";